import BottomSheet from '@perpay-web/components/base/BottomSheet/BottomSheet';
import openEnvelope from '@perpay-web/fintech/assets/images/openEnvelope.svg';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './PartnerOnboardingExistingUserModal.scss';

const PartnerOnboardingExistingUserModal = ({
    onClose,
    firstName,
    matchMethod,
    className,
}) => (
    <BottomSheet
        onClose={onClose}
        className={getClassName(className, styles['existing-user-modal'])}
    >
        <div className={styles.container}>
            <div className={styles.welcome}>
                Welcome back, {firstName}! You already have an account with us.
            </div>
            <div className={styles.body}>
                <img
                    className={styles.image}
                    src={openEnvelope}
                    alt='Open Envolope Icon'
                />
                <div className={styles.header}>
                    Check your email{matchMethod === 'both' && ' & text'}
                </div>
                <div className={styles.info}>
                    We sent you a link that&apos;ll log you in and continue your
                    application.
                </div>
            </div>
            <span className={styles.footer}>
                Didn&apos;t receive a link?{' '}
                <a href={paths.login.path}>Login using your password</a>
            </span>
        </div>
    </BottomSheet>
);
export default PartnerOnboardingExistingUserModal;
